export default __webpack_public_path__ + "static/media/undraw_super_thank_you_re_f8bo.5e484a8a.svg";